import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UiBottomNavItem } from './bottom-navigation.types';

export type { UiBottomNavItem };

/**
 * Organismo: barra de navegación inferior tipo app (solo iconos).
 *
 * Navega entre secciones, a diferencia de `ui-icon-tab-bar`, que son pestañas
 * dentro de una vista. El texto de cada ítem viaja en `aria-label`.
 *
 * Solo presentación; sin HTTP ni Router inyectado.
 */
@Component({
  selector: 'ui-bottom-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bottom-navigation.component.html',
  styleUrl: './bottom-navigation.component.scss',
  host: {
    class: 'ui-bottom-navigation-host',
  },
})
export class UiBottomNavigationComponent {
  readonly items = input<readonly UiBottomNavItem[]>([]);

  /** Valor de la sección activa. Acepta los `matchValues` de cada ítem. */
  readonly selectedValue = input<string | null>(null);

  readonly ariaLabel = input('Navegación principal');

  readonly itemSelect = output<string>();

  protected isActive(item: UiBottomNavItem): boolean {
    const selected = this.selectedValue();
    if (!selected) return false;
    if (item.value === selected) return true;
    return item.matchValues?.includes(selected) ?? false;
  }

  protected onItemClick(item: UiBottomNavItem): void {
    if (item.disabled) return;
    this.itemSelect.emit(item.value);
  }
}
